/**
 * Carrier Portal — FreightSimple's carrier-facing web app.
 *
 * Shares the Hubble shell (ui-core + app-shell) but with a far simpler
 * provider stack: no MSAL, no MSW, no sales-call context. Authentication is
 * the deliberate divergence point and lives app-local under src/App/Auth.
 */
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import { ThemeProvider } from "@freightsimple/ui-core/Theme/ThemeProvider";
import { Toaster } from "@freightsimple/ui-core/Feedback/Toaster";
import { ErrorBoundary } from "@freightsimple/app-shell/ErrorBoundary";
import { App } from "@/App/App";
import { migrateLegacyViewParam } from "@/App/carrierRoutes";
import "./index.css";

// Bookmarked login links predate routing and point at `?view=<section>`.
// Rewrite before the first render so there is no flash of the wrong section.
migrateLegacyViewParam();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ThemeProvider
      storageKey="carriers:theme"
      backgrounds={{ light: "#eef0f4", dark: "#111115" }}
    >
      <ErrorBoundary>
        <TooltipPrimitive.Provider delayDuration={0}>
          <App />
          <Toaster />
        </TooltipPrimitive.Provider>
      </ErrorBoundary>
    </ThemeProvider>
  </StrictMode>,
);
